import { render, staticRenderFns } from "./auction-item-card.vue?vue&type=template&id=a1258894&scoped=true&"
import script from "./auction-item-card.vue?vue&type=script&lang=js&"
export * from "./auction-item-card.vue?vue&type=script&lang=js&"
import style0 from "./auction-item-card.vue?vue&type=style&index=0&id=a1258894&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1258894",
  null
  
)

export default component.exports